import { render, staticRenderFns } from "./db-groups-editable-name.vue?vue&type=template&id=b9284b22&"
import script from "./db-groups-editable-name.vue?vue&type=script&lang=js&"
export * from "./db-groups-editable-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports